import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import ImageUpdate from "./ImageUpdate";
import { Editor } from "components/shared/Editor";

const Overview = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);
  const [sliders, setSliders] = useState([]);
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = useForm();

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "home",
        slug: "aboutUs",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);

    setSliders(section?.sliders);

    setSelectedImage({
      preview: null,
      path: section?.image,
    });
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    // if (!selectedImage?.path) {
    //   toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
    //   return;
    // }

    data.firstImage = `/uploads/${data.firstImage?.split("/").pop()}`;
    data.secondImage = `/uploads/${data.secondImage?.split("/").pop()}`;
    data.thirdImage = `/uploads/${data.thirdImage?.split("/").pop()}`;
    delete data.slug;

    dispatch(
      editSection({
        page: "home",
        slug: "aboutUs",
        data: { section: data },
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"about"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col md={12}>
                <Row>
                  <Col lg={6} xs={12}>
                    <Controller
                      name="firstImage"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { value, onChange } }) => (
                        <ImageUpdate
                          title="firstImage"
                          value={value}
                          setValue={(value) => onChange(value)}
                        />
                      )}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Controller
                      name="secondImage"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { value, onChange } }) => (
                        <ImageUpdate
                          title="secondImage"
                          value={value}
                          setValue={(value) => onChange(value)}
                        />
                      )}
                    />
                  </Col>
                  <Col lg={5} xs={12}>
                    <Controller
                      name="thirdImage"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { value, onChange } }) => (
                        <ImageUpdate
                          title="thirdImage"
                          value={value}
                          setValue={(value) => onChange(value)}
                        />
                      )}
                    />
                  </Col>
                  <Row />
                  {/* --------------------------------------- */}
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id="firstHeading" /> ({" "}
                        <FormattedMessage id="arabic-language" /> )
                      </h5>
                      <input
                        type="text"
                        className="form-control form-outline"
                        {...register("firstTitle.ar")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"firstHeading"} /> ({" "}
                        <FormattedMessage id={"english-language"} /> )
                      </h5>
                      <input
                        type="text"
                        className="form-control form-outline"
                        {...register("firstTitle.en")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id="heading" /> ({" "}
                        <FormattedMessage id="arabic-language" /> )
                      </h5>
                      <input
                        type="text"
                        className="form-control form-outline"
                        {...register("heading.ar")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"heading"} /> ({" "}
                        <FormattedMessage id={"english-language"} /> )
                      </h5>
                      <input
                        type="text"
                        className="form-control form-outline"
                        {...register("heading.en")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"description"} /> ({" "}
                        <FormattedMessage id={"arabic-language"} /> )
                      </h5>
                      <textarea
                        type="text"
                        className="form-control form-outline"
                        {...register("description.ar")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"description"} /> ({" "}
                        <FormattedMessage id={"english-language"} /> )
                      </h5>
                      <textarea
                        type="text"
                        className="form-control form-outline"
                        {...register("description.en")}
                      />
                    </div>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Row />
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"experienceYears"} />
                      </h5>
                      <input
                        type="number"
                        className="form-control form-outline"
                        {...register("years")}
                      />
                    </div>
                  </Col>
                  <Row />
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"experienceYearsText"} /> ({" "}
                        <FormattedMessage id={"arabic-language"} /> )
                      </h5>
                      <input
                        className="form-control form-outline"
                        {...register("yearsSubTitle.ar")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"experienceYearsText"} /> ({" "}
                        <FormattedMessage id={"english-language"} /> )
                      </h5>
                      <input
                        type="text"
                        className="form-control form-outline"
                        {...register("yearsSubTitle.en")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"yearsDescription"} /> ({" "}
                        <FormattedMessage id={"arabic-language"} /> )
                      </h5>
                      {/* <textarea
                        className="form-control form-outline"
                        {...register("yearsDescription.ar")}
                      /> */}
                      <Editor
                        initialValue={watch("yearsDescription.ar")}
                        onChange={(e, editor) => {
                          const data = editor.getContent();
                          setValue("yearsDescription.ar", data);
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"yearsDescription"} /> ({" "}
                        <FormattedMessage id={"english-language"} /> )
                      </h5>
                      {/* <textarea
                        className="form-control form-outline"
                        {...register("yearsDescription.en")}
                      /> */}
                      <Editor
                        initialValue={watch("yearsDescription.en")}
                        onChange={(e, editor) => {
                          const data = editor.getContent();
                          setValue("yearsDescription.en", data);
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"secondDescription"} /> ({" "}
                        <FormattedMessage id={"arabic-language"} /> )
                      </h5>
                      <textarea
                        className="form-control form-outline"
                        {...register("secondDescription.ar")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"secondDescription"} /> ({" "}
                        <FormattedMessage id={"english-language"} /> )
                      </h5>
                      <textarea
                        className="form-control form-outline"
                        {...register("secondDescription.en")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"link"} />
                      </h5>
                      <input
                        className="form-control form-outline"
                        {...register("link.en")}
                      />
                    </div>
                  </Col>
                </Row>

                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Overview;
